import React from 'react';
import CardAuth from './components/CardAuth';

const AuthPage = () => {
    return (
        <CardAuth />
    );
};

export default AuthPage;
